import { render } from "./AssetProfile.vue?vue&type=template&id=aa5937d6"
import script from "./AssetProfile.vue?vue&type=script&lang=js"
export * from "./AssetProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__